import { LitElement, html, css } from 'lit';
import {customElement, property} from 'lit/decorators.js'
import 'datatables.net-responsive-dt';
import $ from 'jquery';
import { ConfigColumnDefs, Config } from 'datatables.net';
import { datatableCSS, datatableResponsiveCSS } from './vxc_datatable.styles'
import tableCSS from './vxc_table.styles'
import { TModal } from './vxc_modal';
import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: true})
const md2html = (md: string) => {
	return marked(md)
}


@customElement('vxc-datatable')
export class TDataTable extends LitElement {
    private datatable: any;
  	@property({ type: Array , attribute: 'data' 	 }) data: Array<any> = [];
  	@property({ type: Array , attribute: 'columns' 	 }) columns: ConfigColumnDefs[] = [];
	@property({ type: String, attribute: 'source' 	 }) source: string = '';
	@property({ type: String, attribute: 'item-title'}) itemTitle: string = '';	// item title for modal view
	@property({ type: String, attribute: 'item-view' }) itemView: string = '';	// item view modal template
	@property({ type: String, attribute: 'item-edit' }) itemEdit: string = '';  // item edit url template

  	static styles = [
		tableCSS,
		datatableCSS,
		datatableResponsiveCSS,
		css`
			:host {
				display: block;
				width: 100%;
				height: 100%;
			}

			table.dataTable {
				width: 100%;
				height: 100%;
				border-collapse: collapse;
				font-size: .85rem;
				overflow: auto;
			}
  	`];


	_renderDatatable() {
		try {
			console.log('init datatable', this.columns, this.data)
			if(this.datatable)	this.datatable.destroy()
			const tableElement = this.shadowRoot!.querySelector('table');
			if(!tableElement)	return
			let cols = this.columns || []
			// let data = this.data || []
			let columnDefs : ConfigColumnDefs[] = cols.map( col => {
				var coldef:ConfigColumnDefs = {...col}
				if(col.render) {
					coldef.render = (data:any, type:string, row:Array<string>) => { 
						return type==='display' ? eval(`\`${col.render}\``) : data 
					}
				}
				if(col.type === 'date' && !col.render) {
					coldef.render = (data:any, type:string, row:Array<string>) => {
						var resp : string = data
						if(type==="display") 
							try { resp = new Date(data).toLocaleString('fr-FR') } catch(e) { console.error(e) }
						return resp
					}
				}
				console.log('coldef :', typeof coldef, coldef)
				return coldef
			})
			let config: Config = {
				columns: columnDefs,
				pageLength: 50,
				lengthChange: false,
				searching: true,
				order: [[1, 'desc']],
				rowCallback: (row: Node, item: any)=> {
                    $(row).on('click', () => {
                        console.log('click', item)
						let modal = this.shadowRoot!.querySelector('vxc-modal') as TModal
						console.log('modal :', modal?.constructor.name)
						if(modal && this.itemView) {
							modal.setAttribute('title', item[this.itemTitle]||'Item')
							modal.innerHTML = eval(`\`${this.itemView}\``)
							modal.show() 
						}
                    });
                }

			} 
			if(this.source) {
				config.ajax = {
					url: this.source,
					type: 'GET',
					headers: {
						'x-api-key': 'my_key'
					},
					dataSrc: ''
				}
			}
			console.log('this.source', this.source)
			console.log('config', config)
			this.datatable = $(tableElement).DataTable(config)


		}
		catch(e) { console.error(e) }
	}

	_updateDatatable() {

	}

	
  	firstUpdated() {
	}

  	updated(changedProperties: Map<string | number | symbol, unknown>) {

	console.log('updated ---> Changed Properties :', changedProperties)

	for(const [key, _] of changedProperties) {
		let prop: string = key as string
		console.log('prop', prop)
		switch(prop) {
			case 'columns':
			case 'data':
			case 'source':
				this._renderDatatable()
				break;
		}
	}
	

	
    // if (changedProperties.has('data')) {
    //   if(this.datatable) {
    //     console.log('update datatable')
    //    this.datatable.clear();
    //    this.datatable.rows.add(this.data);
    //    this.datatable.draw();
    //   }
    // }
  }

  render() {
    console.log('render', this.columns, this.data)
    return html`
		<div style="height: '100%'">
			<table class="table table-striped table-hover"></table>
		</div>
			<vxc-modal size="xl" title=".."></vxc-modal>
    `;
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'vxc-datatable': TDataTable;
  }
}



